export class Weight {
  constructor(amount, unit) {
    this._amount = amount;
    this._unit = unit;
  }

  get unit() {
    return this._unit;
  }

  set unit(unit) {
    this._unit = unit;
  }

  get amount() {
    return this._amount;
  }

  set amount(amount) {
    this._amount = amount;
  }

  isEqualUnit(weight) {
    return this.unit === weight.unit;
  }

  toJSON() {
    return {
      amount: this.amount,
      unit: this.unit,
    };
  }
}
